import React, { useState } from "react";
import "./Feedback.css";

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    subject: "",
    comments: "",
    captcha: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // ==============================
  // INPUT CHANGE
  // ==============================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    if (submitted) {
      setSubmitted(false);
    }
  };

  // ==============================
  // MOBILE NUMBER - ONLY DIGITS
  // ==============================
  const handleMobileKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  // ==============================
  // VALIDATION
  // ==============================
  const validate = () => {
    const newErrors = {};

    // ---------- NAME ----------
    if (!formData.name.trim()) {
      newErrors.name = "Please enter your Name";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    } else if (!/^[a-zA-Z\s.]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can only contain letters, spaces and dots";
    } else if (formData.name.trim().length > 100) {
      newErrors.name = "Name must not exceed 100 characters";
    }

    // ---------- MOBILE ----------
    if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10-digit mobile number";
    } else if (
      formData.mobile &&
      !/^[6-9]/.test(formData.mobile)
    ) {
      newErrors.mobile =
        "Mobile number must start with 6, 7, 8 or 9";
    }

    // ---------- EMAIL ----------
    if (formData.email) {
      if (
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
      ) {
        newErrors.email =
          "Enter email in correct format. Eg: abc@gmail.com";
      } else if (formData.email.length > 100) {
        newErrors.email =
          "Email must not exceed 100 characters";
      }
    }

    // ---------- ADDRESS ----------
    if (formData.address && formData.address.length > 200) {
      newErrors.address =
        "Address must not exceed 200 characters";
    }

    // ---------- SUBJECT ----------
    if (!formData.subject.trim()) {
      newErrors.subject = "Please Enter Subject";
    } else if (formData.subject.trim().length < 3) {
      newErrors.subject =
        "Subject must be at least 3 characters";
    } else if (formData.subject.length > 100) {
      newErrors.subject = "Subject must not exceed 100 characters";
    }

    // ---------- COMMENTS ----------
    if (!formData.comments.trim()) {
      newErrors.comments = "Please enter your Comments";
    } else if (formData.comments.trim().length < 5) {
      newErrors.comments =
        "Comments must be at least 5 characters";
    } else if (formData.comments.length > 500) {
      newErrors.comments =
        "Comments must not exceed 500 characters";
    }

    // ---------- CAPTCHA ----------
    if (!formData.captcha.trim()) {
      newErrors.captcha = "Please Enter Captcha";
    } else if (!/^[a-zA-Z0-9]{4,6}$/.test(formData.captcha.trim())) {
      newErrors.captcha =
        "Captcha must be 4–6 alphanumeric characters";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ==============================
  // SUBMIT
  // ==============================
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setSubmitted(true);

      console.log("Form submitted:", formData);

      // Reset form (optional)
      setFormData({
        name: "",
        mobile: "",
        email: "",
        address: "",
        subject: "",
        comments: "",
        captcha: "",
      });

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // ==============================
  // CAPTCHA REFRESH
  // ==============================
  const reloadCaptcha = () => {
    const img = document.getElementById("captchaImg");

    if (img) {
      img.src = `../../Public/CaptchaImg.aspx?t=${Date.now()}`;
    }

    setFormData((prev) => ({ ...prev, captcha: "" }));

    setErrors((prev) => ({ ...prev, captcha: "" }));
  };

  // ==============================
  // MOBILE NAV
  // ==============================
  const toggleMobileNav = () => {
    setMobileNavOpen((prev) => !prev);
  };

  const closeMobileNav = () => {
    setMobileNavOpen(false);
  };

  return (
    <div className="feedback-page">

      {/* =========================================
          ANIMATED BACKGROUND
      ========================================== */}
      <div className="feedback-bg">
        <span className="bg-circle circle-one"></span>
        <span className="bg-circle circle-two"></span>
        <span className="bg-circle circle-three"></span>
        <span className="bg-grid"></span>
      </div>

      {/* =========================================
          MAIN CONTENT
      ========================================== */}
      <main className="maincontent section-padding">
        <div className="container">

          {/* =====================================
              PAGE HERO
          ====================================== */}
          <div className="feedback-hero">

            <div className="hero-badge">
              <span className="badge-dot"></span>
              Citizen Feedback Portal
            </div>

            <h1>
              Drop Your <span>Question</span>
            </h1>

            <div className="hero-line"></div>
          </div>

          {/* =====================================
              BREADCRUMB
          ====================================== */}
          <div className="breadcrumb-wrapper">
            <ol className="breadcrumb breadcrumb-arrow"></ol>
          </div>

          {/* =====================================
              SUCCESS MESSAGE
          ====================================== */}
          {submitted && (
            <div className="success-message">
              <div className="success-icon">✓</div>

              <div>
                <strong>Thank You!</strong>
                <p>
                  Your suggestion has been submitted successfully.
                </p>
              </div>

              <button
                type="button"
                onClick={() => setSubmitted(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
          )}

          {/* =====================================
              FORM CARD
          ====================================== */}
          <form
            onSubmit={handleSubmit}
            id="form1"
            noValidate
            className="feedback-form"
          >

            <div className="form-card">

              {/* CARD HEADER */}
              <div className="form-card-header">

                <div className="header-icon">
                  ✦
                </div>

                <div>
                  <span className="header-small">
                    SHARE YOUR EXPERIENCE
                  </span>

                  <h2>
                    We'd love to hear from you
                  </h2>

                  <p>
                    Fill in the details below and send us your valuable
                    feedback.
                  </p>
                </div>

              </div>

              {/* =================================
                  FORM BODY
              ================================== */}
              <div className="form-card-body">

                {/* =================================
                    PERSONAL INFORMATION
                ================================== */}
                <div className="form-section-title">
                  <span className="section-number">01</span>

                  <div>
                    <h3>Personal Information</h3>
                    <p>Tell us a little about yourself</p>
                  </div>
                </div>

                <div className="form-grid">

                  {/* NAME */}
                  <div className="form-group">
                    <label htmlFor="name">
                      Name <span className="required">*</span>
                    </label>

                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        maxLength={100}
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>

                    {errors.name && (
                      <span className="error-text">
                        ⚠ {errors.name}
                      </span>
                    )}
                  </div>

                  {/* MOBILE */}
                  <div className="form-group">
                    <label htmlFor="mobile">
                      Mobile Number
                    </label>

                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="mobile"
                        name="mobile"
                        maxLength={10}
                        inputMode="numeric"
                        className={`form-control ${
                          errors.mobile ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your mobile number"
                        value={formData.mobile}
                        onChange={handleChange}
                        onKeyPress={handleMobileKeyPress}
                      />
                    </div>

                    {errors.mobile && (
                      <span className="error-text">
                        ⚠ {errors.mobile}
                      </span>
                    )}
                  </div>

                  {/* EMAIL */}
                  <div className="form-group">
                    <label htmlFor="email">
                      E-mail Address
                    </label>

                    <div className="input-wrapper">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        maxLength={100}
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your email address"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    {errors.email && (
                      <span className="error-text">
                        ⚠ {errors.email}
                      </span>
                    )}
                  </div>

                  {/* ADDRESS */}
                  <div className="form-group">
                    <label htmlFor="address">
                      Address
                    </label>

                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="address"
                        name="address"
                        maxLength={200}
                        className={`form-control ${
                          errors.address ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>

                    {errors.address && (
                      <span className="error-text">
                        ⚠ {errors.address}
                      </span>
                    )}
                  </div>

                </div>

                {/* =================================
                    FEEDBACK INFORMATION
                ================================== */}
                <div className="form-section-title feedback-section-title">
                  <span className="section-number">02</span>

                  <div>
                    <h3>Your Feedback</h3>
                    <p>Share your thoughts and suggestions</p>
                  </div>
                </div>

                <div className="form-grid">

                  {/* SUBJECT */}
                  <div className="form-group">
                    <label htmlFor="subject">
                      Subject <span className="required">*</span>
                      <small>Max 100 letters</small>
                    </label>

                    <div className="textarea-wrapper">
                      <textarea
                        id="subject"
                        name="subject"
                        rows={3}
                        maxLength={100}
                        className={`form-control ${
                          errors.subject ? "is-invalid" : ""
                        }`}
                        placeholder="Enter subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="character-count">
                      {formData.subject.length}/100
                    </div>

                    {errors.subject && (
                      <span className="error-text">
                        ⚠ {errors.subject}
                      </span>
                    )}
                  </div>

                  {/* COMMENTS */}
                  <div className="form-group">
                    <label htmlFor="comments">
                      Comments <span className="required">*</span>
                      <small>Max 500 letters</small>
                    </label>

                    <div className="textarea-wrapper">
                      <textarea
                        id="comments"
                        name="comments"
                        rows={3}
                        maxLength={500}
                        className={`form-control ${
                          errors.comments ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your comments"
                        value={formData.comments}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="character-count">
                      {formData.comments.length}/500
                    </div>

                    {errors.comments && (
                      <span className="error-text">
                        ⚠ {errors.comments}
                      </span>
                    )}
                  </div>

                </div>

                {/* =================================
                    CAPTCHA
                ================================== */}
                <div className="captcha-section">

                  <div className="form-section-title">
                    <span className="section-number">03</span>

                    <div>
                      <h3>Security Verification</h3>
                      <p>Complete the captcha to continue</p>
                    </div>
                  </div>

                  <div className="captcha-grid">

                    {/* CAPTCHA INPUT */}
                    <div className="form-group">
                      <label htmlFor="captcha">
                        Captcha <span className="required">*</span>
                      </label>

                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="captcha"
                          name="captcha"
                          autoComplete="off"
                          maxLength={6}
                          className={`form-control ${
                            errors.captcha ? "is-invalid" : ""
                          }`}
                          placeholder="Enter captcha result"
                          value={formData.captcha}
                          onChange={handleChange}
                        />
                      </div>

                      {errors.captcha && (
                        <span className="error-text">
                          ⚠ {errors.captcha}
                        </span>
                      )}
                    </div>

                    {/* CAPTCHA IMAGE */}
                    <div className="captcha-preview">

                      <div className="captcha-card">

                        <div className="captcha-label">
                          Verification Code
                        </div>

                        <div className="captcha-image-row">

                          <img
                            src="../../Public/CaptchaImg.aspx"
                            id="captchaImg"
                            alt="captcha"
                            className="captcha-img"
                          />

                          <button
                            type="button"
                            className="refresh-button"
                            onClick={reloadCaptcha}
                            title="Refresh Captcha"
                          >
                            ↻
                          </button>

                        </div>

                        <span className="captcha-hint">
                          Can't read it? Refresh the code
                        </span>

                      </div>

                    </div>

                  </div>

                </div>

                {/* =================================
                    SUBMIT AREA
                ================================== */}
                <div className="submit-area">

                  <div className="submit-info">
                    <span className="secure-icon">🔒</span>

                    <span>
                      Your information is safe and secure
                    </span>
                  </div>

                  <button
                    type="submit"
                    className="form-button"
                  >
                    <span>Submit Suggestion</span>
                    <span className="button-arrow">→</span>
                  </button>

                </div>

              </div>
            </div>
          </form>
        </div>
      </main>

      {/* =========================================
          MOBILE NAV
      ========================================== */}
      <nav
        className={`mobile-nav ${
          mobileNavOpen ? "open" : ""
        }`}
      >

        <div className="mobile-nav-header">
          <div>
            <span>Student School</span>
            <strong>Darpan</strong>
          </div>

          <button
            type="button"
            onClick={closeMobileNav}
            className="mobile-close"
          >
            ×
          </button>
        </div>

        <ul>

          <li className="home-icon">
            <a
              href="/"
              title="Portal Home"
              onClick={closeMobileNav}
            >
              <span>⌂</span>
              Portal Home
            </a>
          </li>

          <li>
            <a href="/" onClick={closeMobileNav}>
              Search Schools
            </a>
          </li>

          <li>
            <a href="/" onClick={closeMobileNav}>
              Search Schemes
            </a>
          </li>

          <li>
            <a href="" onClick={closeMobileNav}>
              Prayas
            </a>
          </li>

          <li>
            <a href="/" onClick={closeMobileNav}>
              NAS Question Bank
            </a>
          </li>

          <li>
            <a href="/" onClick={closeMobileNav}>
              Board Exam Question Bank
            </a>
          </li>

          <li className="active">
            <a href="/" onClick={closeMobileNav}>
              Suggestions from citizen
            </a>
          </li>

          <li className="mobile-reports">
            <span>Reports</span>

            <ul>
              <li>
                <a href="/" onClick={closeMobileNav}>
                  School
                </a>
              </li>

              <li>
                <a href="/" onClick={closeMobileNav}>
                  Student
                </a>
              </li>

              <li>
                <a href="/" onClick={closeMobileNav}>
                  Staff
                </a>
              </li>
            </ul>
          </li>

        </ul>
      </nav>

      <div
        className={`mobile-nav-overlay ${
          mobileNavOpen ? "active" : ""
        }`}
        onClick={closeMobileNav}
      />

    </div>
  );
};

export default Feedback;